<template>
    <v-container>
        <v-card class="card">
            <v-card-text>
                <v-form ref="form">
                    <div class="funcionalidade-container">
                        <h3>Configuração de consulta ao CRIVO</h3>
                        <v-row>
                            <v-col cols="12" class="mb-1" style="color:var(--gray);font-weight: 700;">
                                Consulta obrigatória para Grupos Pontuais?
                            </v-col>
                            <v-col cols="12" style="display: inline-flex">
                                <v-radio-group row v v-model="options.optionSpecificGroups"
                                               style="margin-top: 7px; margin-right: -20px; padding-top: 0">
                                    <v-radio label="Desabilitar" :value=constant.DESABILITAR></v-radio>
                                    <v-radio label="Habilitar" :value=constant.HABILITAR></v-radio>
                                    <v-radio label="Habilitar para:" :value=constant.HABILITAR_PARA></v-radio>
                                </v-radio-group>
                                <div class="div--comboBox">
                                    <Autocomplete :class="{ isDisabled: options.optionSpecificGroups !== constant.HABILITAR_PARA, comboBoxEnorme: true }" :items="usuarios"
                                                  v-model="usuariosSelecionados.SpecificGroups" item-text="showText" item-value="id_usuario"
                                                  placeholder="Selecione os usuários" :max-items="MAX_USUARIOS" multiple hide-details
                                                  :disabled="options.optionSpecificGroups !== constant.HABILITAR_PARA"
                                                  :close-button-on-left="true" />
                                </div>
                            </v-col>
                            <v-col cols="12" class="mt-2" v-if="options.optionSpecificGroups === constant.HABILITAR || options.optionSpecificGroups === constant.HABILITAR_PARA">
                                Bloquear venda para Grupos Pontuais?
                                <ToggleButton class="ml-4" v-model="options.blockSaleSpecifcGroups" :sync="true" :labels="false" :color="getPrimaryColor()"></ToggleButton>
                            </v-col>
                        </v-row>
                        <v-row class="mt-10">
                            <v-col cols="12" class="mb-1" style="color:var(--gray);font-weight: 700;">
                                Consulta obrigatória para Grupos Convencionais?
                            </v-col>
                            <v-col cols="12" style="display: inline-flex">
                                <v-radio-group row v v-model="options.optionConventionalGroups"
                                               style="margin-top: 7px; margin-right: -20px; padding-top: 0">
                                    <v-radio label="Desabilitar" :value=constant.DESABILITAR></v-radio>
                                    <v-radio label="Habilitar" :value=constant.HABILITAR></v-radio>
                                    <v-radio label="Habilitar para:" :value=constant.HABILITAR_PARA></v-radio>
                                </v-radio-group>
                                <div class="div--comboBox">
                                    <Autocomplete :class="{ isDisabled: options.optionConventionalGroups !== constant.HABILITAR_PARA, comboBoxEnorme: true }"
                                                  :items="usuarios"
                                                  v-model="usuariosSelecionados.ConventionalGroups" item-text="showText" item-value="id_usuario"
                                                  placeholder="Selecione os usuários" :max-items="MAX_USUARIOS" multiple hide-details
                                                  :disabled="options.optionConventionalGroups !== constant.HABILITAR_PARA"
                                                  :close-button-on-left="true" />
                                </div>
                            </v-col>
                            <v-col cols="12" class="mt-2" v-if="options.optionConventionalGroups === constant.HABILITAR || options.optionConventionalGroups === constant.HABILITAR_PARA">
                                Bloquear venda para Grupos Convencionais?
                                <ToggleButton class="ml-4" v-model="options.blockSaleConventionalGroups" :sync="true" :labels="false" :color="getPrimaryColor()"></ToggleButton>
                            </v-col>
                        </v-row>
                        <v-row class="mt-10">
                            <v-col cols="12" class="mb-1" style="color:var(--gray);font-weight: 700;">
                                Consulta obrigatória para Grupos "Pra Já"?
                            </v-col>
                            <v-col cols="12" style="display: inline-flex">
                                <v-radio-group row v v-model="options.optionPraJaGroups"
                                               style="margin-top: 7px; margin-right: -20px; padding-top: 0">
                                    <v-radio label="Desabilitar" :value=constant.DESABILITAR></v-radio>
                                    <v-radio label="Habilitar" :value=constant.HABILITAR></v-radio>
                                    <v-radio label="Habilitar para:" :value=constant.HABILITAR_PARA></v-radio>
                                </v-radio-group>
                                <div class="div--comboBox">
                                    <Autocomplete :class="{ isDisabled: options.optionPraJaGroups !== constant.HABILITAR_PARA, comboBoxEnorme: true }"
                                                  :items="usuarios"
                                                  v-model="usuariosSelecionados.PraJaGroups" item-text="showText" item-value="id_usuario"
                                                  placeholder="Selecione os usuários" :max-items="MAX_USUARIOS" multiple hide-details
                                                  :disabled="options.optionPraJaGroups !== constant.HABILITAR_PARA"
                                                  :close-button-on-left="true" />
                                </div>
                            </v-col>
                            <v-col cols="12" class="mt-2" v-if="options.optionPraJaGroups === constant.HABILITAR || options.optionPraJaGroups === constant.HABILITAR_PARA">
                                Bloquear venda para Grupos "Pra Já"?
                                <ToggleButton class="ml-4" v-model="options.blockSalePraJaGroups" :sync="true" :labels="false" :color="getPrimaryColor()"></ToggleButton>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" class="d-flex justify-center mt-12 mt-md-4  justify-md-end">
                                <v-btn class="px-md-5 px-10" color="primary" rounded @click="saveFunctionality">
                                    Salvar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </div>
                </v-form>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
  import { alert, notification } from '@/plugins/helpers'
  import { ToggleButton } from 'vue-js-toggle-button'
  import { flavorRes } from '@/plugins/flavors'

  const DESABILITAR = 0
  const HABILITAR = 1
  const HABILITAR_PARA = 2

  export default {
    name: 'ConfigCreditAnalysis',
    components: { ToggleButton },
    data: () => ({
      usuarios: [],
      usuariosSelecionados: {
        SpecificGroups: [],
        ConventionalGroups: [],
        PraJaGroups: []
      },
      usuariosSelecionadosTemp: {
        SpecificGroups: [],
        ConventionalGroups: [],
        PraJaGroups: []
      },
      options: {
        optionSpecificGroups: '',
        optionConventionalGroups: '',
        optionPraJaGroups: '',
        blockSaleConventionalGroups: false,
        blockSaleSpecifcGroups: false,
        blockSalePraJaGroups: false
      },
      constant: {
        DESABILITAR,
        HABILITAR,
        HABILITAR_PARA
      }
    }),
    computed: {
      MAX_USUARIOS: () => 80
    },
    async mounted () {
      await this.getConfig()
      await this.loadUsuarios()
      this.tratarUsuarios()
    },
    methods: {
      getPrimaryColor () {
        const color = flavorRes('values/colors').default
        return color.primary
      },
      tratarUsuarios () {
        let espaco
        let usuarios = this.usuarios.map((usuario) => {
          espaco = ' - '
          if (usuario.login == null) {
            usuario.login = ''
            espaco = ''
          }
          return {
            id_usuario: usuario.id_usuario,
            nome: usuario.nome,
            showText: usuario.login + espaco + usuario.nome
          }
        })
        this.tratarUsuariosSelecionados(
          usuarios,
          'SpecificGroups'
        )
        this.tratarUsuariosSelecionados(
          usuarios,
          'ConventionalGroups'
        )
        this.tratarUsuariosSelecionados(
          usuarios,
          'PraJaGroups'
        )

        this.usuarios = usuarios.sort(this.ordenar)
      },
      async loadUsuarios () {
        await this.$http
          .get('/painel/configuracao/usuarios')
          .then((result) => {
            if (result.data) {
              this.usuarios = result.data.usuarios
              this.tratarUsuarios()
            }
          })
          .catch((err) => notification('error', err, 'Não foi possível buscar os usuários!'))
      },
      tratarUsuariosSelecionados (usuarios, atributo) {
        this.usuariosSelecionados[atributo] = usuarios.filter((usuario) =>
          this.usuariosSelecionadosTemp[atributo].includes(usuario.id_usuario)).map(usuario => usuario.id_usuario)
      },
      async saveFunctionality () {
        if ((this.options.optionSpecificGroups === this.constant.HABILITAR_PARA && this.usuariosSelecionados.SpecificGroups.length === 0) ||
          (this.options.optionConventionalGroups === this.constant.HABILITAR_PARA && this.usuariosSelecionados.ConventionalGroups.length === 0)) {
          alert({
            title: 'Atenção!',
            text: 'Necessário informar ao menos 1 usuário para acesso das funcionalidades listadas.',
            buttons: {
              Fechar: () => true
            }
          })
          return
        }

        await this.$http.post('/painel/configuracao/credito-analise/salvar',
                              {
                                options: this.options,
                                users: this.usuariosSelecionados
                              })
          .then((res) => {
            return notification('success', 'Configurações atualizadas com sucesso!')
          })
          .catch((e) => notification('error', e, 'Não foi possível atualizar as configurações'))
      },
      async getConfig () {
        await this.$http.get('/painel/configuracao/credito-analise').then((res) => {
          const data = res.data
          const config = data.config[0]
          this.options.blockSaleSpecifcGroups = config.bloqueia_venda_grupo_pontual
          this.options.blockSaleConventionalGroups = config.bloqueia_venda_grupo_convencional
          this.options.blockSalePraJaGroups = config.bloqueia_venda_grupo_pra_ja
          this.options.optionSpecificGroups = config.consulta_grupo_pontual
          this.options.optionConventionalGroups = config.consulta_grupo_convencional
          this.options.optionPraJaGroups = config.consulta_grupo_pra_ja

          this.usuariosSelecionadosTemp['SpecificGroups'] = data.SpecificGroups
          this.usuariosSelecionadosTemp['ConventionalGroups'] = data.ConventionalGroup
          this.usuariosSelecionadosTemp['PraJaGroups'] = data.PraJaGroup
        })
      }
    }
  }
</script>

<style scoped>
    .v-card__text {
        margin-top: 8px;
    }

    .row {
        align-items: center;
    }

    .v-input__control {
        align-items: center;
        justify-items: center;
    }

    .v-input {
        display: flex;
        align-items: center;
    }

    .v-input--selection-controls {
        margin-top: 1.5rem;
    }

    .mt-7 {
        align-self: flex-end;
    }

    .inline-anti-quebra-layout {
        display: inline-flex;
    }

    h3 {
        margin-bottom: 20px;
    }

    .div--comboBox {
        width: 65%;
        overflow: auto;
    }

    .comboBoxEnorme {
        max-width: 100%;
        margin: 16px !important;
    }

    .comboBox_container {
        width: 100%;
    }

    .comboBox {
        width: 100%;
        overflow: auto;
        margin: 16px;
        margin-left: 0px !important;
    }

    .parametros__sistema__h4 {
        margin-top: 15px;
        margin-bottom: 15px;
    }

    .isDisabled {
        overflow: hidden;
        margin: 16px !important;
        border-radius: 10px;
        background-color: #efefef !important;
    }

    @media (max-width: 1360px) {
        .comboBoxEnorme {
            max-width: 40%;
            margin: 20px !important;
        }
    }

    @media (max-width: 1600px) {
        .comboBoxEnorme {
            max-width: 100%;
            padding-top: 0;
            margin: 16px !important;
        }

        .div--comboBox {
            max-width: 55%;
        }
    }
</style>
